module.exports = {"APP_NAME":"wynk_web","About":"About","Hello world !":"Hello world !","Home":"Home","Logged in as":"Logged in as","Login":"Login","Logout":"Logout","Password":"Password","Password is required":"Password is required","Username":"Username","Username is required":"Username is required","Username or password incorrect.":"Username or password incorrect.","Remember me":"Remember me","Version":"Version"}


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/translations/en-US.json
// module id = ../../../../../src/translations/en-US.json
// module chunks = main